export const URL_ACCOUNT_CHANNELS = 'https://account.buffer.com/channels'
